import React from 'react';
import { Box, Typography } from '@mui/material';
import ProspoLogo from '../../assets/images/icons/Prospo.svg';

interface NewSessionGreetingProps {
  firstName?: string | null;
}

export const NewSessionGreeting: React.FC<NewSessionGreetingProps> = ({ firstName }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        gap: 2,
        py: 4,
        px: 2,
        textAlign: 'center',
      }}
    >
      <Box
        component="img"
        src={ProspoLogo}
        alt="Prospo"
        sx={{
          width: 65,
          height: 65,
          mb: 1,
          objectFit: 'cover',
          objectPosition: 'left center',
        }}
      />
      <Typography sx={{ fontSize: '1.375rem', fontWeight: 700, color: 'text.primary', lineHeight: 1.35, maxWidth: 320 }}>
        {firstName ? `Hi ${firstName}, how can I help you today?` : 'How can I help you today?'}
      </Typography>
    </Box>
  );
};
